<template>
  <div style="padding-bottom: 40px">
    <div class="plan-page">
      <div class="table">
        <el-table v-if="tableData" v-loading="loading"
          :header-cell-style="{ 'color': 'black', 'letter-spacing': '1px', 'font-size': '18px', 'font-weight': '400' }"
          :cell-style="{ padding: '4px 0', 'color': 'black' }" :data="tableData"
          style="width: 100%;font-size:16px;text-align:center">
          <el-table-column prop="specialty_id" width="666" label="专业名称">
            <template slot-scope="scope">
              <div class="specialty_name">
                <span>{{ scope.row.specialty_id | interpo }} </span>
                <span>{{ scope.row.specialty_name }}</span>
              </div>
              <div class="remarks">{{ scope.row.remarks }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="pici" align="center" label="批次" />
          <el-table-column prop="plan_num" align="center" label="计划余额" />
          <el-table-column prop="num" align="center" label="征集次数" />
          <el-table-column prop="tuition" align="center" label="收费标准">
            <template slot-scope="scope">
              {{ scope.row.tuition }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "GetPlant",
  props: ['school_id'],
  data() {
    return {
      tableData: [],
      loading: false,
    };
  },

  mounted() {
    // this.getNav()
    // 获取批次/科类列表
    this.getPlan();
  },
  methods: {
    getPlan() {

      this.loading = true
      this.$fecth
        .post("enrollment_plan/get_collect", {
          pageSize: 100,
          is_wenli: this.$route.query.is_wenli,
          c_id: this.$route.query.cid,
        })
        .then((res) => {
          res = res.data
          this.loading = false
          this.tableData = res.lists;
          if (this.tableData.length < 1) {
            this.$parent.$data.statess = false
          }
        });
    },

  },

};
</script>

<style lang="less">
.plan-page {
  .search-filter {
    .el-input--mini .el-input__inner {
      background: #F8F8F8;
      border: 0;
      font-size: 16px;
      color: black;
    }

    .el-select .el-input .el-select__caret {
      color: black;
    }
  }
}
</style>

<style lang="less" scoped>
.plan-page {
  width: 1200px;
  margin: auto;
  background-color: #ffffff;
  border-radius: 8px;
  padding-top: 38px;

  .title {
    margin-top: 30px;
    font-size: 22px;
    color: #4591F6;
  }

  .college-item {
    margin-top: 40px;
    margin-bottom: 10px;


    .title {
      font-size: 18px;
      font-weight: normal;
      line-height: 18px;
      color: black;
      margin-right: 30px;

    }

    .school_name {
      color: #A7A7A7;
      border: 1px solid #A7A7A7;
      margin-right: 20px;
      font-size: 18px;
      padding: 2px 5px;
      margin-bottom: 10px;
      border-radius: 5px;
      display: inline-block;
    }

    .hove {
      color: #4591F6;
      border: 1px solid #EFF5FF;
      background: #EFF5FF;

    }
  }

  .table {
    margin: 15px 0 0;

    .specialty_name {
      font-size: 18px;
      color: #000000;
      margin-bottom: 12px;
      margin-top: 24px;
    }

    .remarks {
      font-size: 16px;
      color: #000000;
      margin-bottom: 18px;
    }
  }
}
</style>
